import React, { useEffect, useState } from 'react';
import api from '../../../utils/api';
import PortalPageShell, { PortalEmpty, PortalLoading } from '../PortalPageShell';
import { Card, CardContent } from '../../ui/card';

export default function PortalStudentMarks() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/portal/student/results');
        if (!cancelled) setResults(res.data?.data ?? []);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <PortalPageShell title="Marks" description="Published exam results">
      {loading ? <PortalLoading /> : null}
      {!loading && results.length === 0 ? <PortalEmpty message="No published results yet." /> : null}
      <Card>
        <CardContent className="pt-4">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left text-muted-foreground">
                  <th className="py-2 pr-4">Exam</th>
                  <th className="py-2 pr-4">Subject</th>
                  <th className="py-2">Marks</th>
                </tr>
              </thead>
              <tbody>
                {results.map((r) => (
                  <tr key={r.id} className="border-b border-border/60">
                    <td className="py-2 pr-4">{r.exam_name}</td>
                    <td className="py-2 pr-4">{r.subject_name}</td>
                    <td className="py-2">{r.marks_obtained ?? r.marks} / {r.max_marks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </PortalPageShell>
  );
}
